var React = require('react');

function Up (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / arrow / up"),React.createElement("g",{"id":"icons-/-arrow-/-up","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"arrow-up","fill":"#1E1E1E","transform":"translate(11.997500, 12.047000) scale(1, -1) translate(-11.997500, -12.047000) ","points":"10.997 0.09 10.997 20.176 6.704 15.883 5.29 17.297 11.997 24.004 18.705 17.297 17.29 15.883 12.997 20.176 12.997 0.09"}))]);
}

Up.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Up;

Up.default = Up;
